import React from "react";
import { Card, Box, Grid, Typography, Button } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import axios from "../../utils/fvAxios";
import { useEffect } from "react";
import Status from "../../stories/StatusComponent/StatusComponent";

import { useTranslation } from "react-i18next";
import "../../Localization/i18n";
import { ToastContainer, toast } from "react-toastify";
import { getOrgType } from "../../utils/Token";

export default function VendorLocationCard({ Name, Data, refresh, Refresh }) {
  const [open, setOpen] = React.useState(false);
  const [sitesId, setSitesId] = React.useState();
  const params = new URLSearchParams(window.location.search);
  const PQID = params.get("pqid");

  const { t } = useTranslation();

  const handleClickOpen = (e) => {
    setSitesId(e)
    setOpen(true);
  };
  const Delete = () => {
    handleDelete();
    setOpen(false);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const toastNotify = (message, isSuccess = true) => {
    if (isSuccess) {
      toast.success(message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  async function handleDelete() {
    const res = await axios.post("/Prequalification/DeletePQSiteSync?pqId=" + PQID + "&pqSiteId=" + sitesId);
    toastNotify(res.data.responseMessage, true);
    refresh(true);
  }
  //const pqSiteId = Data.find((r) => (r.prequalificationSitesId));

  return (
    <>
      <>
        <Box sx={{ width: "auto", padding: 1 }}>
          {Name == "null" ? "Global Locations" : Name}
        </Box>
        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
        >
          {Data?.map((r, i) => (
            <Grid item xs={12} sm={3} md={3} key={i} >
              <Box border={1} borderLeft={1} borderRight={1} borderColor="#e4e7ec" className="mt-2" sx={{ width: "auto", padding: "10px" }} >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    padding: "5px",

                    "& hr": {
                      mx: 0.5,
                    },
                  }}
                >
                  <h5
                    className="card-title"
                    style={{
                      fontSize: "17px",
                      marginBottom: 10,
                      color: "#667085",
                      marginRight: "auto",
                      marginTop: 1,
                      fontWeight: "bolde"
                    }}
                  >
                    {r.businesUnitsiteName}
                  </h5>
                  <DeleteOutlineIcon
                    sx={{ color: "#98A2B3", cursor: "pointer" }}
                    onClick={() => handleClickOpen(r.prequalificationSitesId)}
                    hidden={getOrgType() == "Client"}
                  />
                </Box>
                <Status type={r.pqSiteStatus} />
              </Box>
            </Grid>
          ))}
        </Grid>
      </>

      <Dialog
        open={open}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle> {t('VendorDetails.label10')}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {t('VendorDetails.label9')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{t('VendorDetails.label7')}</Button>
          <Button onClick={Delete}>{t('VendorDetails.label8')}</Button>
        </DialogActions>
      </Dialog>

    </>
  );
}